import defaultImage from "../../media/background_images/default-image-sapore.jpg";

export default function ImageRenderer(imageURL) {
    if (imageURL.includes('invalid_url')){
        return defaultImage
    }
    return imageURL
}
